import { Map, Feature } from 'ol';
import * as toastr from "toastr";
import { INode, FeatureType, IFeatureTypeOptions, ICAMSKey, IFeaturesRequest, IMapInteractionConfig, IAPIResult, TextPack } from '../Shared/Models/UtilityModels';

import * as events from '../Shared/Bus/Bus';
import { Utilities,ModalAction } from '../Shared/Utility/Utilities';

export class Reparent {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private wizardState: { camsKeys?: Array<ICAMSKey>, featureSelected?: ICAMSKey };
    private subscriptionSingleFeatureSelected;

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

        $('#reparentWizardCloseBtn').on('click', function () { self.wizard_Close() });
        $('#reparentWizard_SaveBtn').on('click', function () { self.wizard_Save() });
        $('reparentWizard_CancelBtn').on('click', function () { self.wizard_Cancel() });
    }

    // ----------------------------------------------------------- //
    // New Maint WIZARD
    public wizard_Start = (data: Array<ICAMSKey>): void => {
        const self = this;

        // Reset everything
        this.wizardState = { camsKeys: data };
        events.bus.publish(events.eventClearEditLayer());
        events.bus.publish(events.eventResetAllPanels());
        $('#reparentWizard_SaveBtn').prop('disabled', true);
        if (self.subscriptionSingleFeatureSelected) self.subscriptionSingleFeatureSelected();

        // Show the panel
        $('#reparentWizardPanel').addClass('show');

        // Prompt the user to select a feature
        let interactionData: IMapInteractionConfig = { zoomToSelectedFeatures: false, addToExistingSelection: false, selectableLayers: [FeatureType.Route, FeatureType.Infra, FeatureType.Land] };
        events.bus.publish(events.eventStartSingleSelection(interactionData))

        // Listen for the geom selection
        self.subscriptionSingleFeatureSelected = events.bus.subscribe(events.eventSingleFeatureSelected, m => {
            self.subscriptionSingleFeatureSelected();
            self.wizardState.featureSelected = self.convertFeatureToCAMSKey(m.payload);
            $('#reparentWizard_SaveBtn').prop('disabled', false);
        });
    }

    private wizard_Save = (): void => {
        const self = this;
        self.ReparentItems();
    }

    private wizard_Close = (): void => {
        events.bus.publish(events.eventResetAllPanels());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventResetAllButtons(true));
        events.bus.publish(events.eventClearAllHighlights());
        if (this.subscriptionSingleFeatureSelected) this.subscriptionSingleFeatureSelected();
    }

    private wizard_Cancel = (): void => {
        events.bus.publish(events.eventResetAllPanels());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventResetAllButtons(true));
        events.bus.publish(events.eventClearAllHighlights());
        if (this.subscriptionSingleFeatureSelected) this.subscriptionSingleFeatureSelected();
    }

    // ----------------------------------------------------------- //
    // SEND TO SERVER
    private ReparentItems = (): void => {
        const self = this;

        let url = "/OfficerMap/Reparent";
        let query = { camsKeys: self.wizardState.camsKeys, toParent: self.wizardState.featureSelected };

        Utilities.BlockUI($('#reparentWizardPanel'));
        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        //toastr.success("Completed operation");
                        Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CompletedOperation" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                        self.wizard_Close();
                    }
                    else {
                        if (result.data && result.data.message) toastr.error(result.data.message);
                        else toastr.error('Failed to reparent data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
                finally {
                    Utilities.UnBlockUI($('#reparentWizardPanel'));
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // MISC
    private convertFeatureToCAMSKey = (feature: Feature): ICAMSKey => {
        var key: ICAMSKey = {};
        let props = feature.getProperties();

        if (props.MaintCode != null) {
            key.featureType = FeatureType.Maint;
            key.code = props.MaintCode;
        }
        else if (props.RouteCode != null) {
            key.featureType = FeatureType.Route;
            key.code = props.RouteCode;
        }
        else if (props.InfraCode != null) {
            key.featureType = FeatureType.Infra;
            key.code = props.InfraCode;
        }
        else if (props.LandCode != null) {
            key.featureType = FeatureType.Land;
            key.code = props.LandCode;
        }
        else if (props.AnnotationGeomID != null) {
            key.featureType = FeatureType.Annotation;
            key.code = props.AnnotationGeomID;
        }
        return key;
    }
}




